import { Component } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { RepairNumber } from '../volkswagen.types';

@Component({
  selector: 'app-xml-repair-number',
  standalone: true,
  template: `
    <div></div>
  `,
})
export class RepairNumberComponent extends XMLElementBaseComponent<RepairNumber> {}
